import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import Login from './components/Login';
// import Nav from './components/Nav';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import AddUser from './components/addUser/AddUser';
import PatientProfile from './components/patientProfile/PatientProfile';
import EditProfile from './components/patientProfile/EditProfile';
import Users from './components/Users';
import Reviews from './components/Reviews';
import CaregiverProfile from './components/CaregiverProfile';
import EditCaregiver from './components/EditCaregiver';
import AdminProfile from './components/AdminProfile';
import EditAdmin from './components/EditAdmin';
import ChangePassword from './components/ChangePassword';
import Appointments from './components/appointments/Appointments';
import EnrollmentForm from './components/EnrollmentForm';
import { authenticatedPage } from './components/authenticatedPage.js';
import './App.css';

const LoginContainer = () => (
  <div>
    <Redirect exact from='/' to='/login' />
    <Route exact path='/login' component={Login} />
  </div>
)


const DefaultContainer = () => (
  <div>
    <Sidebar />
    <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
    <Route exact path="/login" render={() => <Redirect to="/dashboard" />} />
    <Route path="/dashboard" component={Dashboard} />
    <Route path="/add-user" component={AddUser} />
    <Route path="/profile" component={AdminProfile} />
    <Route path="/submissions" component={Reviews} />
    <Route path="/users" component={Users} />
    <Route path="/patient" component={PatientProfile} />
    <Route path="/edit-patient" component={EditProfile} />
    <Route path="/caregiver" component={CaregiverProfile} />
    <Route path="/edit-caregiver" component={EditCaregiver} />
    <Route path="/edit-admin" component={EditAdmin} />
    <Route path="/change-password" component={ChangePassword} />
    <Route path="/appointments" component={Appointments} />
  </div>
)

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
          <Switch>
            <Route exact path="/login" component={LoginContainer}/>
            <Route path="/enrollment-form" component={EnrollmentForm}/>
            <Route component={authenticatedPage(DefaultContainer)} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js